"use client";
import React from "react";
import "./index.scss";
import { request } from "@/config/request";
import { ENUM_SYSTEM_SOURCE } from "@/const/enum";
import { useAtom } from "jotai";
import { atomCustomerDetail } from "@/model/CustomerDetail";
import { togglePlat } from "@/config/request/interceptors";
import { CustomerDetail, Plat } from "@/model";
import { toTheCkb } from "@/utils/router";
import { setCookieShopId, setCookieToken } from "@/utils";
import { PlatCookie, ShopCookie, TokenSignCookie } from "@/config";
// import { lang } from "@/utils/language";

interface PlatDTO {
  label: string;
  path: string;
  name: string;
  type: ENUM_SYSTEM_SOURCE;
}
const Plats = [
  {
    label: "B2B",
    path: "/b2b",
    name: "b2b",
    type: ENUM_SYSTEM_SOURCE.B2B,
  },
  {
    label: "D2C",
    path: "/d2c",
    name: "d2c",
    type: ENUM_SYSTEM_SOURCE.D2C,
  },
];
interface TogglePlatProps {
  systemSource: ENUM_SYSTEM_SOURCE;
}

/** 写入其他同域项目兼容的 localStorage 数据结构。 */
const setSharedLocalStorage = (
  key: string,
  value: string | number | undefined,
) => {
  /** 空值使用空对象表示退出或无可用店铺。 */
  const storageValue = value === undefined || value === "" ? {} : { val: value };
  window.localStorage.setItem(key, JSON.stringify(storageValue));
};

/** 将平台状态同时同步到根路径 Cookie 和同域 localStorage。 */
const syncSharedPlatform = (systemSource: ENUM_SYSTEM_SOURCE | number) => {
  /** 各项目约定的平台字符串。 */
  const plat =
    systemSource === ENUM_SYSTEM_SOURCE.B2B ? "b2b" : "d2c";
  togglePlat(systemSource);
  setSharedLocalStorage(PlatCookie, plat);
  window.localStorage.setItem("systemSource", String(systemSource));
};

/** 通知其他已打开的同域系统刷新并重新读取平台状态。 */
const notifySharedReload = () => {
  window.localStorage.setItem(
    "_reload_page_",
    Math.random().toString().slice(2),
  );
};

const TogglePlat = (props: TogglePlatProps) => {
  const { systemSource } = props;

  const [useInfo] = useAtom(CustomerDetail);
  /** 防止连续点击导致切换接口被重复调用。 */
  const switchingRef = React.useRef(false);
  /** B2B D2C切换 */
  const changePlat = async (item: PlatDTO) => {
    if (+systemSource === item.type || switchingRef.current) return;
    switchingRef.current = true;
    try {
      if (useInfo?.customerId) {
        /** 切换接口返回的新登录态。 */
        const res = await request.customer.changeLogin.changeLogin();
        if (res.data?.token) {
          /** 接口返回的系统类型是当前登录态的最终状态。 */
          const nextSystemSource =
            res.data?.customerRespDTO?.systemSource ?? item.type;
          /** 切换后当前系统可用的首个店铺。 */
          const firstShopId =
            res.data?.customerShopList?.[0]?.customerShopId;
          syncSharedPlatform(nextSystemSource);
          setCookieToken(res.data.token);
          setSharedLocalStorage(TokenSignCookie, res.data.token);
          setCookieShopId(
            firstShopId === undefined ? "" : String(firstShopId),
          );
          setSharedLocalStorage(ShopCookie, firstShopId);
          notifySharedReload();
          window.location.reload();
        }
      } else {
        syncSharedPlatform(item.type);
        notifySharedReload();
        window.location.reload();
      }
    } finally {
      switchingRef.current = false;
    }
  };
  return (
    <div id="toggle-plat" className="ml-[30px]">
      {Plats.map((item) => {
        return (
          <div
            onClick={() => changePlat(item)}
            className={
              +systemSource === item.type ? "plat-btn active" : "plat-btn"
            }
            key={item.name}
          >
            {item.label}
          </div>
        );
      })}
    </div>
  );
};
export default TogglePlat;
